module.exports = {
    stepone:'一站式浏览所有合作的业务服务，随时查阅各媒体投放信息及相关报告',
    steptwo:'定制化的市场研究及行业动态，精准聚焦更垂直的洞察',
    stepthree:'个性化的消息管理，账号管理，财务管理，助力推广活动更便捷',
    stepfour:'各媒体广告花费及投放效果概览，快速掌握投放期间的ROI',
    stepfive:'更多的媒体资源及新闻动态，玩转最新营销潮流',
    jump:'跳过',
    next:'下一步',
    know:'我知道了',
    allviews:'概览',
    yhf:'为您查询',
    rrt:'条数据关于',
    homeTitle: "主页",
    bh:'返回首页',
    aggregatorTitle:'聚合媒体营销',
    aggregatorTitleMkt:'聚合媒体营销',
    localMediaTitle: "本地媒体营销",
    kol_mkt: "网红营销",
    kol_mkt1: "网红营销",
    submitok:'提交成功',
    havedel:'该文件已经被删除',
    kol_mkt2:'网红营销',
    moreadv:'获取更多信息请联系你专属的顾问：',
    allcost:'所有媒体花费',
    nolimitfonts:'请先联系您的广告主开通此模块',
    noau:'没有权限',
    yadv:'您的专属顾问：',
    jianshe:'此页面正在建设中',
    working:'我们正在努力！',
    noauth:'抱歉！您没有权限进入这个页面',
    saveok:'保存成功',
    csud:'复制成功',
    moredetail:'你也可以先去媒体资源看看',
    gome:'跳转至媒体资源',
    newsno:'暂无数据',
    formaterror:'上传错误！请检查文件类型：jpg、jpeg、png、gif、bmp、txt、doc、docx、ppt、pptx、pdf、rar、zip、mp4',
    compilited:'请先完成表格数据',
    Overview:'概览',
    coverit:'请上传图片',
    nodate:'Opps,没有数据',
    openfirst:'请先开通此服务',
    sh:'查询历史',
    NN:'暂无通知',
    ND:'暂无数据',
    NSR:'暂无搜索结果',
    fillinfi:'请先填写本条数据的媒体资源',
    potsf:'请先打开此服务',
    local_mkt:'本地媒体营销',
    aggregator_mkt:'聚合媒体营销',
    // programmatic_mkt:'程序化营销',
    programmatic_mkt:'程序化营销',
    programmatic_mkt_manage:'程序化营销(网盟数据)',
    moveSuccess:'移动成功',
    rs:'相关查询结果',
    total:'共',
    item:'页',
    havetop:'已经在顶部了',
    Updated:'已更新',
    items:'条数据',
    reserveone:'请至少保留一个数据。',
    havebottom:'已经在底部了',
    errors:'接口报错',
    goodstaff:'很棒的东西我们已经准备好了，他们正在路上。',
    other:'其他',
    existed:'媒体资源已存在',
    existedcountry:'相同媒体资源下的国家不能相同',
    appMkt:'应用市场',
    newUser:'新用户获取',
    Retargeting:'老用户召回',
    revShare:'用户购买分成',
    appAnalysisReports:'应用分析报告',
    market_analysis_rep:'市场分析报告',
    Marketservice:'市场服务',
    today:'昨天',
    monthToDate:'本月至昨日',
    overallSpend:'总花费',
    cost:"花费",
    pleaseOpenTheServiceFirst:"请先开通服务",
    LocalMedia:'本地媒体营销',
    adn_service:'ADN服务',
    mediaCostTrendsInLast7Days:"媒体过去7天花费趋势分布",
    top5ProductsInLast7DaySpend:'过去7天花费排名前5的产品',
    whatsNew:'新闻',
    viewMode:'查看更多',
    exhibitionWall:'展示墙',
    highQualityResources:'优质资源',
    getAccessNow:'立即获取权限',
    itsunderconstruction:'正在建设中',
    dashboard:'数据概览',
    influencer: '网红营销',
    more: '更多',
    allNews: '所有消息',
    activities: '活动',
    awards: '奖项',
    allMessages: '所有消息',
    taskReminder: '任务提醒',
    productUpdate: '产品更新',
    resources: '资源',
    report: '报告',
    viewAllNotifications: '查看所有通知',
    clickHereTip: '更多详细信息，请点击这里',
    howCanHelp: '您好，有什么可以帮忙的吗？',
    viewNow: '现在查看',
    viewAll: '查看全部',
    operatingManuals: '操作手册',
    learnMore: '学习更多',
    describeorSearchKeyword: '描述您的问题或搜索关键字',
    advertiserSetting:'广告主设置',
    userSetting:'用户设置',
    others:'媒体服务',
    Overseas:' 全球',
    Europe:'欧洲',
    North_American:'北美洲',
    South_American:'南美洲',
    Southeast_Asia:'东南亚',
    the_Middle_East:'中东',
    Africa:'非洲',
    India:'印度',
    Indonesia:'印尼',
    Japan:'日本',
    South_Korea:'韩国',
    China:'中国',
    zome:'按区域过滤',
    fbp:'按产品过滤',
    bangdan:'榜单分析',
    jingpin:'竞品分析',
    psya:'请填写应用名称',
    psyp:'请选择平台',
    savenews:'保存&新增',
    Generate:'生成密码',
    KolTracking:'网红流程',
    LocalMediaLift: '电梯媒体',
}



// WEBPACK FOOTER //
// ./src/i18n/modules/home/zh-cn.js